/*
 * Sportsact: opsalg "Passer perfekt med" (snippets/custom-upsell.liquid)
 * Uden manuelt valgt produkt hentes først "complementary" (Search & Discovery), derefter "related"
 * (eller i den rækkefølge, attributten intents angiver).
 * Kortet renderes af sections/custom-upsell-recommendations.liquid, som kun returnerer tilgængelige produkter.
 */
(() => {
  // Scriptet kan indlæses flere gange (kurvskuffen gen-renderer sektioner), så kør kun første gang
  if (window.customElements.get('custom-upsell')) return;

  class CustomUpsell extends HTMLElement {
    async connectedCallback() {
      if (this.dataset.source || this.dataset.loading) {
        return;
      }

      this.dataset.loading = 'true';

      // Rækkefølgen kan styres med attributten intents (fx "related,complementary" til udsolgt-alternativet)
      const intents = (this.getAttribute('intents') || 'complementary,related').split(',').map((intent) => intent.trim());

      for (const intent of intents) {
        const html = await this.#fetchCard(intent);

        if (html) {
          this.querySelector('.custom-upsell__content').innerHTML = html;
          this.dataset.source = intent;
          this.hidden = false;
          break;
        }
      }

      delete this.dataset.loading;
    }

    async #fetchCard(intent) {
      try {
        const url = `${window.Shopify.routes.root}recommendations/products?product_id=${this.getAttribute('product-id')}&limit=10&intent=${intent}&section_id=custom-upsell-recommendations`;
        const response = await fetch(url);

        if (!response.ok) {
          return null;
        }

        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const card = doc.querySelector('.custom-upsell-card');
        return card ? card.outerHTML : null;
      } catch (error) {
        return null;
      }
    }
  }

  window.customElements.define('custom-upsell', CustomUpsell);

  // Opdater prisen i kortet, når en anden variant vælges
  document.addEventListener('change', (event) => {
    const select = event.target.closest('.custom-upsell-card__select');
    const price = select?.closest('.custom-upsell-card')?.querySelector('.custom-upsell-card__price sale-price');
    const option = select?.selectedOptions[0];

    if (price && option?.dataset.price) {
      const label = price.querySelector('.sr-only');
      price.textContent = option.dataset.price;
      if (label) {
        price.prepend(label);
      }
      price.closest('.price-list')?.querySelector('compare-at-price')?.remove();
    }
  });
})();
